import { useAuth } from '@/lib/auth';
import { setLeoOnDuty, useLeoOnDuty } from '@/lib/duty';
import { useOverlay } from './Overlay';

// The one switch in the header of the four main screens (Gary, 19 Oct): Available, or Leo on duty.
export function DutySwitch() {
  const { session } = useAuth();
  const { toast } = useOverlay();
  const live = !!session && session.user.id !== 'preview';
  const onDuty = useLeoOnDuty(live);
  if (!live || onDuty === null) return null;
  const flip = () => void setLeoOnDuty(!onDuty).then((ok) => {
    if (!ok) { toast('That did not save. Try again.'); return; }
    toast(onDuty ? 'Available: you answer your chats within 10 minutes' : 'Leo on duty: Leo answers your chats');
  });
  return (
    <button type="button" className={`chats-chip chats-duty${onDuty ? ' chats-duty--leo' : ' active'}`} onClick={flip} aria-pressed={onDuty}
      title={onDuty ? 'Leo is answering your chats. Tap when you are available again.' : 'You answer your chats. Tap to put Leo on duty.'}>
      {onDuty ? 'Leo on duty' : 'Available'}
    </button>
  );
}
